import { Calendar } from "lucide-react";

type Item = { year: number; text: string };

export function VerticalTimeline({ items }: { items: Item[] }) {
  return (
    <div className="relative max-w-3xl mx-auto">
      {/* Vertical line */}
      <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-secondary rounded-full"></div>
      
      <div className="space-y-6 md:space-y-8">
        {items.map((item, index) => {
          const isLeft = index % 2 === 0;
          const cardClasses = isLeft
            ? "bg-slate-900 text-white border-white/10"
            : "bg-secondary text-slate-900 border-secondary";
          const yearClasses = isLeft ? "text-secondary" : "text-slate-900";
          
          return (
            <div key={item.year} className="relative flex items-center">
              {/* Timeline dot */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 md:w-5 md:h-5 bg-secondary rounded-full border-3 border-white shadow-lg z-10"></div>
              
              {/* Content card */}
              <div className={`w-full md:w-5/12 ${isLeft ? 'md:mr-auto md:pr-6' : 'md:ml-auto md:pl-6'}`}>
                <div className={`relative rounded-xl border p-4 md:p-5 shadow-lg ${cardClasses} mx-4 md:mx-0`}>
                  <div className={`flex items-center gap-2 text-lg md:text-xl font-black mb-1 ${yearClasses}`}>
                    <Calendar className="w-4 h-4 md:w-5 md:h-5" />
                    {item.year}
                  </div>
                  <div className="font-semibold leading-snug text-sm md:text-base">{item.text}</div>
                  
                  {/* Arrow pointing to timeline - hidden on mobile */}
                  <div 
                    className={`hidden md:block absolute top-4 w-0 h-0 ${
                      isLeft 
                        ? 'right-[-10px] border-l-[10px] border-l-current border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent' 
                        : 'left-[-10px] border-r-[10px] border-r-current border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent'
                    } ${isLeft ? 'text-slate-900' : 'text-secondary'}`}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}